import type { CurrentUser, DisplayUser } from './types';

export const toDisplayUser = ({
  userId,
  firstName,
  lastName,
  emailAddress,
}: CurrentUser): DisplayUser => {
  const first = firstName.trim();
  const last = lastName.trim();
  return {
    userId,
    firstName: first,
    fullName: [first, last].filter(Boolean).join(' '),
    email: emailAddress.trim(),
    initials: `${first.charAt(0)}${last.charAt(0)}`.toUpperCase(),
  };
};
